var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgShoe(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.003 2c.571 2.176 1.81 5.282 4.002 5.282h3.425l1.708 8.39c.286 1.864 6.862 2.039 6.862 4.97v.848h-7.144c-1.478 0-2.453-.93-3.865-2.296l.01-.01L4.458 8.028 10.003 2zM3.552 9.01l.03.033 10.57 11.188.019.022c1.424 1.377 2.729 2.663 4.685 2.663H26V25h-7.144c-1.791 0-3.483-.617-6.003-3.109L2 10.703l1.552-1.694z",
    fill: "#000",
    fillRule: "nonzero"
  })));
}

export default SvgShoe;